import React from 'react';
import { useUniversityConfig } from '../../contexts/UniversityConfigProvider';
import { ModernTemplate, ClassicTemplate } from './index';
import MinimalTemplate from './MinimalTemplate';

const Login: React.FC = () => {
  const { config } = useUniversityConfig();
  const template = config?.login?.template || "classic";
  
  switch (template) {
    case "modern":
      return <ModernTemplate />; 
    case "minimal":
      return <MinimalTemplate />; 

    case "classic":
    default:
      return <ClassicTemplate />;
  }
};

export default Login;